<div class="header-menu" *ngIf="isLogin">
  <div class="header-title">
    <!-- <span *ngIf="isShowBack" class=" iconBack" (click)="goBack()">
      <img src="./assets/images/icon_arrow-back.svg" alt="" />
    </span> -->
    <i class="title-icon" nz-icon [nzType]="menu?.icon" nzTheme="outline"></i> 
    <span class="title-visible">{{ menu?.title }}</span>
  </div>

  <div
    class="header-account"
    nz-dropdown
    nzPlacement="bottomRight"
    nzTrigger="click"
    [nzDropdownMenu]="menuDropdown"
  >
    <nz-avatar nzIcon="user"></nz-avatar>
    <span class="user-name">{{ userName }}</span>
    <i nz-icon nzType="caret-down" nzTheme="outline"></i>
  </div>

  <nz-dropdown-menu #menuDropdown="nzDropdownMenu">
    <ul nz-menu class="user-dropdown">
      <li nz-menu-item routerLink="/fox-admin/settings/user/updatePassword">
        <span class="custom-icon">
          <img src="./assets/images/icon_key.svg" alt="" />
        </span>
        <a routerLink="/fox-admin/settings/user/updatePassword">Đổi mật khẩu</a>
      </li>
      <li nz-menu-item (click)="logout()">
        <span class="custom-icon">
          <img src="./assets/images/icon_logout-nav.svg" alt="" />
        </span>
        <a> Đăng xuất </a>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>
